import Timeline, {TimelineMarkers, TodayMarker} from "react-calendar-timeline";
import * as moment from "moment-timezone";
import {useQuery} from "@apollo/client";
import {useEffect, useState} from "react";
import Box from "@mui/material/Box";

import {ALL_PUBLISHING_PLANS} from "../queries/GraphQLQueries";
import {useTimezone} from "../hooks/useTimezone";
import {CAP_LEVELS} from "../domain/CapLevels";
import useBuffer from "../hooks/useBuffer";

const THOUSAND_HOURS_IN_MILLISECONDS = 1000 * 60 * 60 * 1000;
const THOUSAND_DAYS_IN_MILLISECONDS = 1000 * 86400 * 1000;


export default function ContentPublishingPlansView(props) {

        const { timezone } = useTimezone();

        const {data, loading, error} = useQuery(ALL_PUBLISHING_PLANS);
        const [planItems, setPlanItems] = useState([]);
        const [bufferSize, setBufferSize] = useState(1);

        useBuffer(timezone, bufferSize, setBufferSize);

        useEffect(() => {
            if (!data || !data?.contentPublishingPlans) {
                return;
            }

            const convertedPlans = data.contentPublishingPlans.map(plan => {
                return {
                    ...plan,
                    contentName: plan.content.name,
                    capLevel: plan.content.level,
                    from: moment(plan.from),
                    to: moment(plan.to)
                }}).filter(plan => !plan.perpetual);

            setPlanItems(convertedPlans);

        }, [data]);

        const keys = {
            groupIdKey: 'key',
            groupTitleKey: 'name',
            itemIdKey: 'id',
            itemGroupKey: 'capLevel',
            itemTimeStartKey: 'from',
            itemTimeEndKey: 'to',
            itemTitleKey: 'contentName'
        };

        const groupRenderer = ({ group }) => {
            return (
                <span className="custom-group">
                    <div style={{backgroundColor: group.color, width: 20, height: 20, display: "inline-block", margin: 6}}></div>
                    <span className="title">{group.name}</span>
                </span>
            )
        };

        return (
            <Box>
                <Timeline
                    groups={CAP_LEVELS}
                    items={planItems}
                    defaultTimeStart={moment().add(-6, 'months')}
                    defaultTimeEnd={moment().add(6, 'months')}
                    keys={keys}
                    buffer={bufferSize}
                    lineHeight={40}
                    itemHeightRatio={0.8}
                    minZoom={THOUSAND_HOURS_IN_MILLISECONDS}
                    maxZoom={THOUSAND_DAYS_IN_MILLISECONDS}
                    canMove={false}
                    canResize={false}
                    canChangeGroup={false}
                    traditionalZoom={true}
                    stackItems={true}
                    groupRenderer = {groupRenderer}>
                    <TimelineMarkers>
                        <TodayMarker/>
                    </TimelineMarkers>
                </Timeline>
            </Box>
        );
}
